import { forwardRef, useImperativeHandle, useRef } from 'react';
import { RichTextEditor } from '../editor/RichTextEditor';
import type { RichTextEditorHandle } from '../editor/RichTextEditorHandle';
import { RequiredMark } from '../ui/RequiredMark';
import type { MessageHtmlEditorHandle } from './MessageHtmlEditorHandle';

type MessageHtmlEditorProps = {
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean;
  onFocusField?: () => void;
};

export const MessageHtmlEditor = forwardRef<MessageHtmlEditorHandle, MessageHtmlEditorProps>(
  function MessageHtmlEditor({ value, onChange, disabled = false, onFocusField }, ref) {
    const editorRef = useRef<RichTextEditorHandle>(null);

    useImperativeHandle(
      ref,
      () => ({
        insertText(text: string) {
          editorRef.current?.insertText(text);
        },
      }),
      [],
    );

    return (
      <div className="erp-label erp-form-grid-full" onFocusCapture={onFocusField}>
        Mensagem <RequiredMark />
        <div className="mt-1">
          <RichTextEditor
            ref={editorRef}
            value={value}
            onChange={onChange}
            readOnly={disabled}
            minHeight="220px"
            placeholder="Escreva a mensagem. Use as macros para personalizar."
          />
        </div>
      </div>
    );
  },
);
